import React from 'react';
import MessengerCustomerChat from 'react-messenger-customer-chat';

const FacebookMessanger = () => {
    return (
        <div>
            <MessengerCustomerChat
    pageId="109506457517909"
    appId="1129655667770758"
  />,
        </div>
    );
};

export default FacebookMessanger;